export const SupportWidgetError = () => null;
